<template>
    <el-dialog :title="$t('editAdvertBook')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog"
               top="10vh">
        <div class="content">
            <el-form :model="formData"
                     size="mini"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <el-form-item :label="$t('merchant')"
                              prop="merchantId">
                    <el-select v-model="formData.merchantId" filterable @change="merchantChange">
                        <el-option v-for="item in merchantOptions"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('shop')"
                              prop="shopIds">
                    <el-select
                        v-model="formData.shopIds"
                        multiple
                        collapse-tags
                        filterable>
                        <el-option
                            v-for="item in shopOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('advertBookName')"
                              prop="name">
                    <el-input v-model="formData.name"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('timeFrame')" prop="date">
                    <el-date-picker
                        v-model="formData.date"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="-"
                        :start-placeholder="$t('startDate')"
                        :end-placeholder="$t('endDate')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('advertClassify')"
                              prop="showcaseCategoryIds">
                    <el-select
                        v-model="formData.showcaseCategoryIds"
                        multiple
                        collapse-tags>
                        <el-option
                            v-for="item in classifyOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item :label="$t('whetherEnable')"-->
                <!--              prop="enabled">-->
                <!--    <el-switch-->
                <!--        v-model="formData.enabled"-->
                <!--        active-color="#13ce66"-->
                <!--        inactive-color="#dcdfe6">-->
                <!--    </el-switch>-->
                <!--</el-form-item>-->
                <el-form-item :label="$t('cover')" prop="cover">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        action=""
                        :http-request="httpRequest"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <img :src="formData.cover" class="avatar" v-if="formData.cover">
                        <div class="avatar-icon">
                            <i class="el-icon-delete" @click.stop="handleRemoveImage" v-if="formData.cover"></i>
                            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    updateAdvertBook,
    queryAdvertBookDetails,
    searchMerchantList,
    queryMerchantShop,
    uploadImage,
    searchAdvertClassifyList
} from "@/api/modules/api";

export default {
    name: 'Edit',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            dialogVisible: false,
            formData: {
                merchantId: '',
                shopIds: [],
                name: '',
                date: '',
                showcaseCategoryIds: [],
                enabled: true,
                cover: ''
            },
            rules: {
                merchantId: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                shopIds: [{ type: 'array', required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                date: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                showcaseCategoryIds: [{ type: 'array', required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                // enabled: [{ required: true, message: this.$t('pleaseSelectHint'), trigger: 'change' }],
                cover: [{ required: true, message: this.$t('uploadCoverHint'), trigger: 'change' }],
            },
            merchantOptions: [],
            shopOptions: [],
            classifyOptions: [],
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            // 获取详情
            this.getDetails()
            // 获取商家列表
            if (this.merchantOptions.length === 0) {
                this.getMerchantOptions()
            }
            // 获取广告分类列表
            if (this.classifyOptions.length === 0) {
                this.getClassifyOptions()
            }
        },
    
        // 获取详情
        getDetails () {
            queryAdvertBookDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    // 商家
                    if (resData.merchantId) {
                        this.getShopOptions(resData.merchantId, false)
                    }
                    // 门店
                    let shops = resData.shops || []
                    let shopIds = shops.map(item => {
                        return item.id
                    })
                    // 日期
                    let date = ''
                    if (resData.startedAt && resData.endedAt) {
                        let startTime = this.$moment(resData.startedAt).format('YYYY-MM-DD')
                        let endTime = this.$moment(resData.endedAt).format('YYYY-MM-DD')
                        date = [startTime, endTime]
                    }
                    // 分类
                    let showcaseCategorys = resData.showcaseCategorys || []
                    let showcaseCategoryIds = showcaseCategorys.map(item => {
                        return item.id
                    })
                    this.formData = {
                        merchantId: resData.merchantId,
                        shopIds,
                        name: resData.name,
                        date: date,
                        showcaseCategoryIds,
                        enabled: resData.enabled || false,
                        cover: resData.cover
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
    
        // 获取商家列表
        getMerchantOptions() {
            const params = {
                name: ''
            }
            searchMerchantList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.merchantOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        // 切换商家
        merchantChange (val) {
            // 获取商家门店列表
            this.getShopOptions(val)
            let nowMerchant = this.merchantOptions.find(item => {
                return item.id === val
            })
            if (nowMerchant.showcaseCategorys instanceof Array) {
                this.formData.showcaseCategoryIds = nowMerchant.showcaseCategorys.map(item => item.id)
            } else {
                this.formData.showcaseCategoryIds = []
            }
        },
        
        // 获取商家门店列表
        getShopOptions(id, b = true) {
            const params = {
                merchantId: id,
                name: ''
            }
            queryMerchantShop(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.shopOptions = res.data || []
                    // 清空已选门店
                    if (b) {
                        this.formData.shopIds = []
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        // 获取广告分类列表
        getClassifyOptions() {
            const params = {
                type: ''
            }
            searchAdvertClassifyList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.classifyOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        /******** 图片 ********/
        httpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.formData.cover = res.data.url;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err);
                })
        },
        // 清除图片
        handleRemoveImage () {
            this.formData.cover = ''
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            let date = this.formData.date
            let startedAt = ''
            let endedAt = ''
            if (date instanceof Array && date.length === 2) {
                let startTime = date[0] + ' 00:00:00'
                let endTime = date[1] + ' 23:59:59'
                startedAt = this.$moment(startTime).format('YYYY-MM-DDTHH:mm:ssZZ')
                endedAt = this.$moment(endTime).format('YYYY-MM-DDTHH:mm:ssZZ')
            }
            const params = {
                id: this.parentId,
                merchantId: this.formData.merchantId,
                shopIds: this.formData.shopIds,
                name: this.formData.name.trim(),
                startedAt,
                endedAt,
                enabled: this.formData.enabled,
                showcaseCategoryIds: this.formData.showcaseCategoryIds,
                cover: this.formData.cover
            }
            this.disabled = true;
            updateAdvertBook(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/form-dialog.scss';
</style>
